// extracted by mini-css-extract-plugin
module.exports = {"box":"adminBar_box__1o-_W","barOpenBtn":"adminBar_barOpenBtn__IRqN8"};